import { createRouter, createWebHistory } from 'vue-router'

const routes = [
  // 登录页（无需鉴权）
  {
    path: '/login',
    name: 'Login',
    component: () => import('../views/LoginView.vue'),
    meta: { public: true }
  },
  // 主布局（含侧边栏）
  {
    path: '/',
    component: () => import('../views/layouts/MainLayout.vue'),
    children: [
      {
        path: '',
        name: 'Home',
        component: () => import('../views/Home.vue'),
        meta: { title: '训练概览' }
      },
      // 角色库
      {
        path: 'roles',
        name: 'RoleList',
        component: () => import('../views/roles/RoleList.vue'),
        meta: { title: '角色库' }
      },
      {
        path: 'roles/create',
        name: 'RoleCreate',
        component: () => import('../views/roles/RoleCreate.vue'),
        meta: { title: '创建角色' }
      },
      {
        path: 'roles/:id/edit',
        name: 'RoleEdit',
        component: () => import('../views/roles/RoleEdit.vue'),
        meta: { title: '编辑角色' }
      },
      {
        path: 'roles/:id',
        name: 'RoleDetail',
        component: () => import('../views/roles/RoleDetail.vue'),
        meta: { title: '角色详情' }
      },
      {
        path: 'voice-register',
        name: 'VoiceRegister',
        component: () => import('../views/voice/VoiceRegister.vue'),
        meta: { title: '音色注册', adminOnly: true }
      },
      // 训练会话
      {
        path: 'session/prepare/:roleId',
        name: 'Prepare',
        component: () => import('../views/session/Prepare.vue'),
        meta: { title: '训练准备' }
      },
      {
        path: 'session/:sessionId',
        name: 'Training',
        component: () => import('../views/session/Training.vue'),
        meta: { title: '训练会话', fullscreen: true }
      },
      // 评估报告
      {
        path: 'report/:sessionId',
        name: 'Report',
        component: () => import('../views/report/Report.vue'),
        meta: { title: '评估报告' }
      },
      // 训练历史
      {
        path: 'history',
        name: 'HistoryList',
        component: () => import('../views/history/HistoryList.vue'),
        meta: { title: '训练历史' }
      },
      {
        path: 'history/:sessionId',
        name: 'HistoryDetail',
        component: () => import('../views/history/HistoryDetail.vue'),
        meta: { title: '历史报告' }
      }
    ]
  },
  // 404
  { path: '/:pathMatch(.*)*', redirect: '/' }
]

const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes
})

// 路由守卫：未登录跳转到登录页
router.beforeEach((to, from, next) => {
  const token = localStorage.getItem('token')
  const userInfo = JSON.parse(localStorage.getItem('userInfo') || 'null')
  if (to.meta.public) {
    next()
  } else if (!token) {
    next({ name: 'Login', query: { redirect: to.fullPath } })
  } else if (to.meta.adminOnly && userInfo?.role !== 'ADMIN') {
    next('/')
  } else {
    next()
  }
})

export default router
